import React, { FC } from "react";
import Link from "next/link";

const AnimefurusatoLpBanner: FC = () => {
  return (
    <Link href="/lp/animefurusato" passHref>
      <a target="_blank" rel="noreferrer">
        <img src="/image/banner/animefurusato/lp.png" alt="" width="300" height="63" loading="lazy" />
      </a>
    </Link>
  )
}
export default AnimefurusatoLpBanner;
